module.exports = __webpack_public_path__ + "static/media/slideImgTree@2x.2be63ad6.svg";